import React from 'react';
import { Route } from 'react-router-dom';

import DocumentTitle from '../generic/DocumentTitle';
import AddOpportunity from './AddOpportunity.container';
import ListOpportunities from './ListCategorizedOpportunities';
import ShowOpportunity from './ShowOpportunity.container';
import UpdateOpportunity from './UpdateOpportunity.container';

function Routes() {
  return (
    <DocumentTitle title="Opportunities">
      <Route path="/opportunities" exact component={ListOpportunities} />
      <Route path="/opportunities/add" component={AddOpportunity} />
      <Route path="/opportunities/:id/show" component={ShowOpportunity} />
      <Route path="/opportunities/:id/edit" component={UpdateOpportunity} />
    </DocumentTitle>
  );
}

export default Routes;
